"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _voyagePlanSearch = require("@/api/vessel/voyagePlanSearch");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'activation',
  data: function data() {
    return {
      isCnLang: false,
      activeTypeName: {
        '0': '已激活（Activated）',
        '1': '激活（Activate）'
      },
      activeTypeEN: {
        '0': 'Activated',
        '1': 'Activation'
      },
      username: '',
      activeflag: '1'
    };
  },
  methods: {
    userActive: function userActive() {
      var _this = this;
      var id = this.$route.params.id;
      (0, _voyagePlanSearch.cancelOrderCargo)(id).then(function (response) {
        if (!(0, _validate.validateNull)(response.data.cargoTrackOrderId)) {
          _this.$alert(_this.$t('voyagePlanSearch.unsubscribeSuccess'), '提示(Tips)', {
            confirmButtonText: '确认(Sure)',
            callback: function callback(action) {}
          });
        } else {
          _this.$alert(JSON.stringify(response.data), '提示(Tips)', {
            confirmButtonText: '确认(Sure)',
            callback: function callback(action) {}
          });
        }
      });
    }
  }
  // created() {
  //   let userId = this.$route.params.id
  //   if (!validateNull(userId)) {
  //     // userActiveInfo(userId).then(response => {
  //     //   this.username = response.data.data.username
  //     //   this.activeflag = response.data.data.delFlag
  //     // })
  //   }
  // }
};